import React from 'react';
import { formConfig } from 'app/pages/BookTripPage/builder';
import { FormattedMessage } from 'translations';
import { connect } from 'react-redux';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import ValidationMessage from 'app/components/base/ValidationMessage';
import style from './style.css';


class FormError extends React.Component {
  handleClick = () => {
    const el = document.querySelector(`input[name="${this.props.fieldName}"]`);
    if (el && el.focus) {
      el.focus();
    }
  }

  render() {
    const { fieldName, errorType } = this.props;
    return (
      <ValidationMessage
        component="li"
        id={`error-${fieldName}`}
        className={style.item}
        onClick={this.handleClick}
        key={fieldName}
        plain
        errorType={errorType}
        fieldName={fieldName}
      />
    );
  }
}

// TODO: move to Flow types
// FormError.propTypes = {
//   fieldName: PropTypes.string.isRequired,
//   errorType: PropTypes.string.isRequired
// };

const icon = {
  name: 'ic-error-1',
  family: 'mozio',
  large: true,
  error: true
};

const messages = {
  title: { id: 'BOOK_TRIP.FORM_ERRORS_TITLE' }
};

const FormErrors = ({
  errors
}) => {
  return !errors ? <div /> : (
    <InteractiveInfoBlock
      direction="column"
      type="red"
      icon={icon}
    >
      <span className={style.title}>
        <FormattedMessage {...messages.title} />
      </span>
      <ul className={style.list}>
        {Object.keys(errors).map((fieldName, index) => (
          <FormError key={index} fieldName={fieldName} errorType={errors[fieldName]} />
        ))}
      </ul>
    </InteractiveInfoBlock>
  );
};

// TODO: move to Flow types
// FormErrors.propTypes = {
//   errors: PropTypes.object.isRequired
// };

const mapStateToProps = (state) => {
  const form = state.form[formConfig.form];
  return {
    errors: form.submitFailed ? form.syncErrors : null
  };
};

export default connect(mapStateToProps)(FormErrors);
